import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from 'vue';
import { useRoute } from 'vue-router';

import NcEmptyContent from '@nextcloud/vue/components/NcEmptyContent';

import { useRouteIs } from '@services/route-is';
import { t } from '@services/l10n';
import { config } from '@services/user-config';

import PeopleIcon from 'vue-material-design-icons/AccountMultiple.vue';
import ImageMultipleIcon from 'vue-material-design-icons/ImageMultiple.vue';
import ArchiveIcon from 'vue-material-design-icons/PackageDown.vue';
import AlbumIcon from 'vue-material-design-icons/ImageAlbum.vue';
import MapIcon from 'vue-material-design-icons/Map.vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'EmptyContent',
},
  __name: 'EmptyContent',
  setup(__props) {



const route = useRoute();
const routeIs = useRouteIs();
const emptyViewDescription = computed((): string => {
  if (routeIs.Base) {
    return t('memories', 'Upload some photos and make sure the timeline path is configured');
  }
  if (routeIs.Favorites) {
    return t('memories', 'Mark photos as favorite to find them easily');
  }
  if (routeIs.ThisDay) {
    return t('memories', 'Memories from past years will appear here');
  }
  if (routeIs.Recognize) {
    return t('memories', 'Recognize is still working on your photos');
  }
  if (routeIs.FaceRecognition) {
    return config.facerecognition_enabled
      ? t('memories', 'You will find your friends soon. Please be patient')
      : t('memories', 'Face Recognition is disabled. Enable in settings to find your friends');
  }
  if (routeIs.Videos) {
    return t('memories', 'Your videos will appear here');
  }
  if (routeIs.Panoramas) {
    return t('memories', 'Your panoramas will appear here');
  }
  if (routeIs.Albums) {
    return route.params.name
      ? t('memories', 'Add photos to albums by selecting them on your timeline.')
      : t('memories', 'Create an album to get started');
  }
  if (routeIs.Archive) {
    return t('memories', "Archive photos you don't want to see in your timeline");
  }
  if (routeIs.Tags) {
    return t('memories', 'Tag photos to find them easily');
  }
  if (routeIs.Places) {
    return t('memories', 'Places you have been to will appear here');
  }
  return String();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NcEmptyContent), {
    name: _unref(t)('memories', 'Nothing to show here'),
    description: emptyViewDescription.value
  }, {
    icon: _withCtx(() => [
      (_unref(routeIs).People)
        ? (_openBlock(), _createBlock(PeopleIcon, { key: 0 }))
        : (_unref(routeIs).Archive)
          ? (_openBlock(), _createBlock(ArchiveIcon, { key: 1 }))
          : (_unref(routeIs).Albums)
            ? (_openBlock(), _createBlock(AlbumIcon, { key: 2 }))
            : (_unref(routeIs).Map)
              ? (_openBlock(), _createBlock(MapIcon, { key: 3 }))
              : (_openBlock(), _createBlock(ImageMultipleIcon, { key: 4 }))
    ]),
    _: 1
  }, 8, ["name", "description"]))
}
}

})